/**
 * @file 404 錯誤頁面
 * @description 找不到頁面時顯示
 */
import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';

import './Error404Style.scss';

/**
 * 404 錯誤元件
 */
function Error404(): ReactNode {
  const navigate = useNavigate();
  return (
    <div id='error404'>
      <div className='error'>404</div>
      <br />
      <br />
      <span className='info'>Page not found</span>
      <br />
      <br />
      <p className='go_back'>
        Try to <span onClick={() => navigate('/')}>[Go Back]</span> or
        <span onClick={() => navigate('/')}>[Return to the Home Page]</span>
      </p>
    </div>
  );
}

export default Error404;
